/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import React from 'react'
import { DragDropContext, Droppable } from 'react-beautiful-dnd'

// const itemRender = ({ key, index, data, updateByIndex, removeByIndex })

const OrderedDragAndDropList = ({
  children,
  items,
  listActions: { updateByIndex, removeByIndex, moveByIndex },
  style = { padding: '16px 0', paddingRight: '24px' },
  itemRender,
}) => {
  const onBeforeDragStart = () => {
    /* ... */
  }

  const onDragStart = () => {
    /* ... */
  }
  const onDragUpdate = () => {
    /* ... */
  }
  const onDragEnd = result => {
    // the only one that is required
    //
    const { destination, source } = result
    if (!destination) {
      return
    }

    if (
      destination.droppableId === source.droppableId &&
      destination.index === source.index
    ) {
      return
    }
    moveByIndex({
      sourceIndex: source.index,
      destinationIndex: destination.index,
    })
  }

  return (
    <DragDropContext
      onBeforeDragStart={onBeforeDragStart}
      onDragStart={onDragStart}
      onDragUpdate={onDragUpdate}
      onDragEnd={onDragEnd}
    >
      <Droppable droppableId="item-droppable" type="ITEM">
        {provided => (
          <div ref={provided.innerRef} {...provided.droppableProps}>
            <div css={style}>
              {items.map((data, index) =>
                itemRender({
                  key: index,
                  index,
                  data,
                  updateByIndex,
                  removeByIndex,
                })
              )}
              {provided.placeholder}
              {children}
            </div>
          </div>
        )}
      </Droppable>
    </DragDropContext>
  )
}

export default OrderedDragAndDropList
